module.exports = __webpack_public_path__ + "static/media/049_g8_4Step 5 Confirm.b3f577d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/049_g8_4Step 5 Confirm.png
// module id = 456
// module chunks = 0